import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useGameStore } from "../../store/gameStore";

/**
 * Global toast for rejected server actions (gameStore.lastError). Without it
 * every refused action (out-of-turn play, wrong declaration, expired
 * session, …) fails silently for the user (F4 fix). Auto-dismisses after a
 * few seconds; ✕ closes it early.
 */
export function ErrorToast() {
  const lastError = useGameStore((s) => s.lastError);
  const setError = useGameStore((s) => s.setError);

  useEffect(() => {
    if (!lastError) return;
    const t = setTimeout(() => setError(null), 5000);
    return () => clearTimeout(t);
  }, [lastError, setError]);

  return (
    <AnimatePresence>
      {lastError && (
        <motion.div
          key={lastError}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.18 }}
          role="alert"
          className="fixed bottom-5 left-1/2 z-50 flex w-[min(92vw,26rem)] -translate-x-1/2 items-center gap-3 rounded-lg border border-crimson-dim bg-surface px-4 py-3 text-sm text-crimson shadow-lg"
        >
          <span className="flex-1">{lastError}</span>
          <button
            aria-label="Chiudi"
            className="shrink-0 rounded px-1.5 text-ink-faint hover:text-ink"
            onClick={() => setError(null)}
          >
            ✕
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
